import React from "react";
import "./ActivityLog.css";
import styled from "styled-components";
import StyledText from "../../components/StyledComponents/StyledText";
import { CorporateTheme } from "../../utils/themes";
import { useTheme } from "../../middleware/ThemeContext";

interface LogEntry {
  id: number;
  time: string;
  description: string;
}

const activityLogs: LogEntry[] = [
  {
    id: 1,
    time: "09:15:22 AM",
    description:
      "Hensiel Daniel (L2) logged in to this account using  logged in to this account using  logged in to this account using  logged in to this account using Mac (IP: 192.168.1.10).",
  },
  {
    id: 2,
    time: "09:15:22 AM",
    description:
      'Hensiel Daniel (L2) created a new member record to a: TechSolutions Inc." (ID: MEM-1001).',
  },
  {
    id: 2,
    time: "09:15:22 AM",
    description:
      'Hensiel Daniel (L2) created a new member record to a: TechSolutions Inc." (ID: MEM-1001).',
  },
];

interface ActivityLogsProps {
  data?: any; // Replace 'any' with a more specific type if possible
}

const ActivityLog= ({data}:ActivityLogsProps) => {
  const { theme } = useTheme();
  return (
    <div >
      {/* <StyledText
        fontSize="16px"
        fontWeight={700}
        textColor={theme.CorporateTheme.colors.headerColor}
        className="mb-0 ps-3 py-3"
      >
        Activity log
      </StyledText>
      <StyledHr theme={theme} className="me-4" /> */}
      <div className="timeline position-relative p-2">
        {activityLogs.map((log, index) => (
          <div
            key={log.id}
            className={`timeline-item position-relative mb-2 ${
              index !== activityLogs.length - 1 ? "timeline-line" : ""
            }`}
          >
            <div className="timeline-dot  border border-white"></div>
            <div className="timeline-content ">
              <p
                className="mb-1"
                style={{
                  fontWeight: 400,
                  fontSize: "14px",
                  color: theme.CorporateTheme?.colors?.paraColor,
                }}
              >
                {log.description}
              </p>
              <small  style={{
                  fontWeight: 600,
                  fontSize: "12px",
                  color: theme.CorporateTheme?.colors?.headerColor,
                }}>{log.time}</small>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ActivityLog;

const StyledBox = styled.div(({ theme }) => ({
  borderRadius: '5px',
  background: theme.CorporateTheme?.colors?.background,
  height: 'auto',
  border: `1px solid ${theme.CorporateTheme?.colors?.border}`,
  boxShadow: '0px 2px 10px 0px #0000000d',
}));

const StyledHr = styled.div`
  margin-bottom: 10px;
  color: ${({ theme }) => theme.CorporateTheme.colors.border};
  border-bottom: 0.5px solid ${({ theme }) => theme.CorporateTheme.colors.border};
`;
